Monitoring.Models.SocialContents ||= {}

class Monitoring.Models.SocialContents.TwitterApiUser extends Backbone.Model

  initialize: (json) ->
    if typeof(json) == "string"
      json = $.parseJSON(twitter)
    if typeof(author) == "string"
      author = $.parseJSON(author)
    @set('json', json)

  name: ->
    return @get('json').name

  username: ->
    return @get('json').username

  link: ->
    return @get('json').link

  avatar: ->
    return @get('json').avatar

  count: ->
    return @get('json').count

  social_network_id: ->
    return @get('json').social_network_id
